export const SITE_URL = 'https://sportplatzgarage.ch';
export const SITE_NAME = 'Sportplatzgarage Gutknecht GmbH';
export const SITE_PHONE = '+41 81 413 27 20';
export const SITE_EMAIL = 'info@sportplatzgarage.ch';
export const SITE_ADDRESS = {
  street: 'Mattastrasse 46',
  postalCode: '7270',
  locality: 'Davos',
  region: 'Graubünden',
  country: 'CH',
};

export const DEFAULT_DESCRIPTION =
  'Sportplatzgarage Gutknecht – stop+go Partner in Davos: VAG-Service, Pannendienst, Mobilitätsgarantie, Carrosserie, Lack, Verglasung, Schadenabwicklung und Diagnose.';

export const DEFAULT_TITLE =
  'Sportplatzgarage Gutknecht | stop+go Garage Davos – VW, Audi, SEAT, Škoda & CUPRA';

export const SAME_AS = [
  'https://partner.stopgo.ch/sportplatzgarage-gutknecht/de',
  'https://www.facebook.com/sportplatzgarage/',
  'https://www.instagram.com/sportplatzgarage_gutknecht/',
  'https://twitter.com/sportplzgarage',
];

export const VAG_BRANDS = [
  {
    slug: 'audi-garage-davos',
    path: '/audi-garage-davos/',
    brand: 'Audi',
    shortName: 'Audi',
    navLabel: 'Audi',
    kicker: 'Audi Service Davos',
    h1: 'Audi Garage & Service in Davos',
    title: 'Audi Garage Davos | Service & Reparatur – Sportplatzgarage Gutknecht',
    description:
      'Audi Service in Davos bei der Sportplatzgarage Gutknecht: Diagnose, Inspektion, Zahnriemen, DSG, Bremsen und Reparaturen nach Herstellervorgaben – stop+go Partner.',
    lead:
      'Sportplatzgarage Gutknecht ist stop+go Partner in Davos und spezialisiert auf Service, Diagnose und Reparaturen an Audi-Fahrzeugen.',
    services: [
      'Audi Inspektion & Service nach Herstellervorgaben',
      'Fahrzeugdiagnose mit aktueller Diagnosetechnik',
      'Zahnriemen- und Wasserpumpenwechsel',
      'DSG-Service und Getriebeservice',
      'Bremsen, Fahrwerk, Klimaanlage und Elektrik',
      'Originalteile und geprüfte Economy-Teile wo sinnvoll',
    ],
  },
  {
    slug: 'vw-garage-davos',
    path: '/vw-garage-davos/',
    brand: 'Volkswagen',
    shortName: 'VW',
    navLabel: 'VW',
    kicker: 'VW Service Davos',
    h1: 'VW Garage & Service in Davos',
    title: 'VW Garage Davos | Volkswagen Service – Sportplatzgarage Gutknecht',
    description:
      'Volkswagen Service in Davos: Inspektion, Diagnose, Zahnriemen, DSG, Haldex und Reparaturen bei der Sportplatzgarage Gutknecht – stop+go Spezialist für VW.',
    lead:
      'Als stop+go Partner betreuen wir Volkswagen in Davos mit Know-how, Originalteilen wo möglich und fairen Werkstattpreisen.',
    services: [
      'VW Inspektion & Wartung',
      'Diagnose und Fehlersuche',
      'Zahnriemen / Steuertrieb',
      'DSG- und Getriebeservice',
      'Haldex-Service (Allrad)',
      'Bremsen, Fahrwerk, Klima, Elektrik',
    ],
  },
  {
    slug: 'skoda-garage-davos',
    path: '/skoda-garage-davos/',
    brand: 'Škoda',
    shortName: 'Škoda',
    navLabel: 'Škoda',
    kicker: 'Škoda Service Davos',
    h1: 'Škoda Garage & Service in Davos',
    title: 'Škoda Garage Davos | Service & Reparatur – Sportplatzgarage Gutknecht',
    description:
      'Škoda Service in Davos bei der Sportplatzgarage Gutknecht: Wartung, Diagnose, Zahnriemen, DSG und Reparaturen – stop+go Partner für den Volkswagen-Konzern.',
    lead:
      'Für Škoda-Fahrzeuge in Davos und Umgebung sind wir Ihr stop+go Ansprechpartner für Service und Reparatur.',
    services: [
      'Škoda Service & Inspektion',
      'Diagnose nach Herstellervorgaben',
      'Zahnriemen und Kühlkreislauf',
      'DSG-Service',
      'Bremsen und Fahrwerk',
      'Klimaservice und Elektrik',
    ],
  },
  {
    slug: 'seat-garage-davos',
    path: '/seat-garage-davos/',
    brand: 'SEAT',
    shortName: 'SEAT',
    navLabel: 'SEAT',
    kicker: 'SEAT Service Davos',
    h1: 'SEAT Garage & Service in Davos',
    title: 'SEAT Garage Davos | Service & Reparatur – Sportplatzgarage Gutknecht',
    description:
      'SEAT Service in Davos: Inspektion, Diagnose und Reparatur bei der Sportplatzgarage Gutknecht – stop+go Spezialist für SEAT und den Volkswagen-Konzern.',
    lead:
      'SEAT-Modelle betreuen wir in Davos als stop+go Partner mit Fokus auf fachgerechten Service und transparente Preise.',
    services: [
      'SEAT Inspektion & Service',
      'Diagnose und Software-Updates wo möglich',
      'Zahnriemen / Steuertrieb',
      'Bremsen, Kupplung, Fahrwerk',
      'Klimaservice',
      'Elektrik und Beleuchtung',
    ],
  },
  {
    slug: 'cupra-service-davos',
    path: '/cupra-service-davos/',
    brand: 'CUPRA',
    shortName: 'CUPRA',
    navLabel: 'CUPRA',
    kicker: 'CUPRA Service Davos',
    h1: 'CUPRA Service & Reparatur in Davos',
    title: 'CUPRA Service Davos | Sportplatzgarage Gutknecht – stop+go',
    description:
      'CUPRA Service in Davos bei der Sportplatzgarage Gutknecht: Diagnose, Wartung und Reparatur – stop+go Partner mit Fokus auf den Volkswagen-Konzern.',
    lead:
      'Auch für CUPRA bieten wir in Davos kompetenten Service und Reparaturen im stop+go Netzwerk.',
    services: [
      'CUPRA Service & Inspektion',
      'Fahrzeugdiagnose',
      'Bremsen und Fahrwerk',
      'Getriebe- und Antriebsservice',
      'Klimaservice',
      'Elektrik und Assistenzsysteme',
    ],
  },
  {
    slug: 'vw-nutzfahrzeuge-davos',
    path: '/vw-nutzfahrzeuge-davos/',
    brand: 'VW Nutzfahrzeuge',
    shortName: 'VW NFZ',
    navLabel: 'VW Nutzfahrzeuge',
    kicker: 'VW Nutzfahrzeuge Davos',
    h1: 'VW Nutzfahrzeuge Service in Davos',
    title: 'VW Nutzfahrzeuge Davos | Transporter Service – Sportplatzgarage Gutknecht',
    description:
      'Service und Reparatur für VW Nutzfahrzeuge in Davos: Transporter, Caddy und Co. bei der Sportplatzgarage Gutknecht – stop+go Partner.',
    lead:
      'Ob Transporter oder Caddy: Für VW Nutzfahrzeuge in Davos stehen wir mit Werkstattkompetenz und fairen Preisen bereit.',
    services: [
      'Service für Transporter, Caddy & Co.',
      'Diagnose und Wartung',
      'Bremsen und Fahrwerk',
      'Kupplung und Antrieb',
      'Klimaservice',
      'MFK-Vorbereitung',
    ],
  },
];

export const HUB_PAGE = {
  path: '/vag-garage-davos/',
  title: 'VAG Garage Davos | VW, Audi, SEAT, Škoda & CUPRA – Sportplatzgarage',
  description:
    'VAG-Garage in Davos: Sportplatzgarage Gutknecht ist stop+go Spezialist für Volkswagen, Audi, SEAT, Škoda und CUPRA – Service und Reparatur zu fairen Preisen.',
  h1: 'Ihre VAG-Garage in Davos',
  kicker: 'stop+go Partner',
  lead:
    'Sportplatzgarage Gutknecht GmbH ist Ihr stop+go Spezialist in Davos für Fahrzeuge des Volkswagen-Konzerns – mit Know-how, Diagnosetechnik und fairen Preisen.',
};

export function absoluteUrl(path = '/') {
  if (!path) return SITE_URL + '/';
  if (path.startsWith('http')) return path;
  return SITE_URL + (path.startsWith('/') ? path : `/${path}`);
}

export function buildLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': ['AutoRepair', 'LocalBusiness'],
    '@id': `${SITE_URL}/#business`,
    name: SITE_NAME,
    alternateName: [
      'Sportplatzgarage Gutknecht',
      'Sportplatzgarage Davos',
      'stop+go Davos',
      'stop+go Sportplatzgarage Gutknecht',
    ],
    description: DEFAULT_DESCRIPTION,
    url: SITE_URL + '/',
    telephone: SITE_PHONE,
    email: SITE_EMAIL,
    image: absoluteUrl('/sportplatzgarage.svg'),
    logo: absoluteUrl('/sportplatzgarage.svg'),
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE_ADDRESS.street,
      addressLocality: SITE_ADDRESS.locality,
      addressRegion: SITE_ADDRESS.region,
      postalCode: SITE_ADDRESS.postalCode,
      addressCountry: SITE_ADDRESS.country,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 46.7945,
      longitude: 9.8202,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '07:30',
        closes: '12:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '13:30',
        closes: '18:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '07:30',
        closes: '12:00',
      },
    ],
    areaServed: [
      { '@type': 'City', name: 'Davos' },
      { '@type': 'AdministrativeArea', name: 'Graubünden' },
    ],
    knowsAbout: [
      'Volkswagen Service',
      'Audi Service',
      'SEAT Service',
      'Škoda Service',
      'CUPRA Service',
      'VW Nutzfahrzeuge',
      'Fahrzeugreparatur',
      'Fahrzeugdiagnose',
      'Pannendienst',
      'Mobilitätsgarantie stop+go',
      'Carrosserie',
      'Lackiererei',
      'Verglasung',
      'Schadenabwicklung',
      'Unfallbergung',
      'Autovermietung',
      'Zahnriemenwechsel',
      'DSG-Service',
      'stop+go',
    ],
    brand: VAG_BRANDS.map((b) => ({ '@type': 'Brand', name: b.brand })),
    sameAs: SAME_AS,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Werkstattleistungen Sportplatzgarage Davos',
      itemListElement: [
        'Fahrzeugreparatur',
        'Fahrzeugdiagnose',
        'Pannendienst',
        'Mobilitätsgarantie stop+go',
        'Carrosserie',
        'Lackiererei',
        'Verglasung',
        'Schadenabwicklung',
        'Unfallbergung',
        'Autovermietung',
        'Ölspurreinigung',
        'Schächte absaugen',
        'Belagsreinigung',
        'Autoservice VAG',
        'MFK-Vorbereitung',
      ].map((name) => ({
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name },
      })),
    },
  };
}

export function buildBrandServiceSchema(brandPage) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: `${brandPage.brand} Service Davos`,
    serviceType: `${brandPage.brand} Service und Reparatur`,
    description: brandPage.description,
    provider: { '@id': `${SITE_URL}/#business` },
    areaServed: { '@type': 'City', name: 'Davos' },
    url: absoluteUrl(brandPage.path),
  };
}

export function getBrandBySlug(slug) {
  return VAG_BRANDS.find((b) => b.slug === slug);
}
